import React from 'react'
import { User } from '../../../types/UserTypes'
import { Box, Typography, List, ListItem } from '@mui/material'

interface Props {
  players: User[];
}

export const Players = ({ players }: Props) => {
  return (
    <Box>
      <Typography variant="h6">Players</Typography>
      <List>
        {players.map((player) => (
          <ListItem key={player.id}>{player.username}</ListItem>
        ))}
      </List>
    </Box>
  )
}
